import Lottie from "lottie-react";
import lottieJson from "./pulse.json";

interface LottieAnimationProps {
  style?: React.CSSProperties;
  onClick?: () => void;
}

const LottieAnimation = ({ style, onClick = () => {} }: LottieAnimationProps) => {
  return (
    <Lottie
      onClick={onClick}
      animationData={lottieJson}
      loop={true}
      style={{
        width: "var(--width-150)",
        ...style,
      }}
    />
  );
};

export default LottieAnimation;
